<template>
  <div>
    <!-- 顶部banner -->
    <div class="banner-pic-container">
      <img src="https://assets.che300.com/feimg/cloud/banner-v2.png" alt />
    </div>

    <!-- 热门服务以及最新上线 -->
    <div class="card-list-container">
      <!-- 热门服务 -->
      <div class="card-list-title" v-if="!axiosSuccess || hotProducts.length">
        <span class="hot-service">热门服务</span>
        <router-link to="/list">
          <span class="see-all-product">
            <span>查看全部产品</span>
            <img src="https://assets.che300.com/feimg/cloud/home-arrow.png" alt />
          </span>
        </router-link>
      </div>
      <div class="list-container">
        <template v-if="axiosSuccess">
          <Card
            v-for="item in hotProducts"
            :key="item.product_uuid"
            :data="item"
            :itemClick="seeDetail"
          />
        </template>
        <template v-else>
          <Bonus v-for="(item,index) in 8" :key="index" />
        </template>
      </div>

      <!-- 最新上线 -->
      <div class="card-list-title" v-if="!axiosSuccess || latestProducts.length">
        <span class="hot-service">最新上线</span>
        <router-link to="/list">
          <span class="see-all-product">
            <span>查看全部产品</span>
            <img src="https://assets.che300.com/feimg/cloud/home-arrow.png" alt />
          </span>
        </router-link>
      </div>
      <div class="list-container">
        <template v-if="axiosSuccess">
          <Card
            v-for="item in latestProducts"
            :key="item.product_uuid"
            :data="item"
            :itemClick="seeDetail"
          />
        </template>
        <template v-else>
          <Bonus v-for="(item,index) in 8" :key="index" />
        </template>
      </div>
    </div>

    <!-- 产品优势 -->
    <div class="product-advantage">
      <div class="product-advantage-box">
        <div class="product-advantage-title">产品优势</div>
        <div class="product-advantage-sub-box">
          <p class="product-advantage-sub-title">通过百家交易平台实时数据，每天捕获超过2,000万条动态信息</p>
          <p class="product-advantage-sub-title">车300建立了海量的汽车信息库，并构建了成为二手车交易标准的估值模型</p>
        </div>
        <ul class="product-advantage-body">
          <li class="product-advantage-body-item" v-for="(item,index) in advanceList" :key="index">
            <img v-lazy="item.image" />
            <h3 class="item-h3">{{item.title}}</h3>
            <p class="item-p">
              {{item.firstDesc}}
              <br />
              {{item.secDesc}}
            </p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 合作案例 -->
    <div class="cooperation-case">
      <div class="cooperation-case-body">
        <div class="cooperation-case-title">合作案例</div>
        <ul class="cooperation-case-body-ul">
          <li class="cooperation-case-body-item" v-for="item in cooperationList" :key="item">
            <img v-lazy="item" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Card from '../components/productCard.vue'
import Bonus from '../components/bonusCard.vue'
export default {
  name: 'Home',
  components: {
    Card,
    Bonus
  },
  data () {
    return {
      axiosSuccess: false,
      hotProducts: [],
      latestProducts: [],
    }
  },
  created () {
    this.getIndexProducts();

    // 产品优势
    this.advanceList = [
      {
        image: 'https://assets.che300.com/feimg/cloud/advance-1.png',
        title: '真实数据',
        firstDesc: '与真实、原始交易数据',
        secDesc: '进行对比验证'
      }, {
        image: 'https://assets.che300.com/feimg/cloud/advance-2.png',
        title: '人工验证',
        firstDesc: '评估师根据各地区二手车市',
        secDesc: '场交易价格进行验证'
      }, {
        image: 'https://assets.che300.com/feimg/cloud/advance-3.png',
        title: '模型验证',
        firstDesc: '通过车300不同应用场景',
        secDesc: '模型进行数据验证'
      }, {
        image: 'https://assets.che300.com/feimg/cloud/advance-4.png',
        title: '抽样验证',
        firstDesc: '从数据内采集随机抽样方',
        secDesc: '式验证二手车价格'
      }
    ];

    // 合作案例
    this.cooperationList = [
      "https://assets.che300.com/feimg/cloud/ysc_home_picc.png",
      "https://assets.che300.com/feimg/cloud/ysc_home_gsyh.png",
      "https://assets.che300.com/feimg/cloud/ysc_home_zsyh.png",
      "https://assets.che300.com/feimg/cloud/ysc_home_webank.png",
      "https://assets.che300.com/feimg/cloud/ysc_home_sqjt.png",
      "https://assets.che300.com/feimg/cloud/ysc_home_tesla.png",
      "https://assets.che300.com/feimg/cloud/ysc_home_gz.png",
      "https://assets.che300.com/feimg/cloud/ysc_home_rrc.png",
      "https://ssl-assets.che300.com/feimg/cloud/pic_payh.png",
      "https://ssl-assets.che300.com/feimg/cloud/pic_pazn.png"
    ];
  },
  methods: {
    // 获取热门服务及最新上线产品
    getIndexProducts () {
      this.$ax('/api/fe/v1/index-products')
        .then(res => {
          this.axiosSuccess = true;
          this.hotProducts = res.data.hot_products;
          this.latestProducts = res.data.latest_products;
        })
        .catch(error => { })
    },
    // 查看产品详情
    seeDetail (id) {
      const routeUrl = this.$router.resolve({
        path: '/product-detail',
        query: {
          uuid: id
        }
      });
      window.open(routeUrl.href, '_blank')
      // this.$router.push({path: '/product-detail',query: { uuid: id }})
    }
  }
}
</script>
<style scoped lang="less">
.banner-pic-container {
  height: 480px;
  background-color: #001836;

  img {
    display: block;
    margin: 0 auto;
    height: 480px;
    max-width: 100vw;
    min-width: 1180px;
  }
}
.card-list-container {
  min-width: 1180px;
}

.card-list-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px auto 0;
  padding-bottom: 10px;
  width: 1180px;
  min-width: 1180px;

  .hot-service {
    font-size: 24px;
    color: #222;
  }
  .see-all-product {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #f70;

    img {
      display: inline-block;
      margin-left: 3px;
    }
  }
}
.list-container {
  margin: 0 auto;
  width: 1180px;
  min-width: 1180px;
}

// 产品优势
.product-advantage {
  margin-top: 60px;
  padding: 60px 0;
  line-height: 1;
  text-align: center;
  background-color: #fff;

  .product-advantage-box {
    margin: 0 auto;
    width: 1180px;
  }
  .product-advantage-title {
    font-size: 24px;
    padding-bottom: 30px;
  }
  .product-advantage-sub-box {
    font-size: 16px;
    line-height: 1.4;
  }
  .product-advantage-body {
    display: flex;
    justify-content: space-around;
  }
  .product-advantage-body-item {
    padding: 40px 40px 36px 40px;
    width: 280px;
    background-color: #fff;
  }
  .item-imgbox {
    margin: 0 auto;
    width: 76px;
    height: 76px;
  }
  .item-h3 {
    padding: 26px 0;
    font-size: 16px;
    font-weight: bold;
    color: #f60;
  }
  .item-p {
    font-size: 14px;
    line-height: 1.25;
  }
}

// 合作案例
.cooperation-case {
  .cooperation-case-body {
    margin: 0 auto;
    padding-bottom: 80px;
    width: 1180px;
    min-width: 1180px;
  }
  .cooperation-case-title {
    padding: 60px 0 40px 0;
    font-size: 24px;
    line-height: 1;
    text-align: center;
  }
  .cooperation-case-body-ul {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .cooperation-case-body-item {
    width: 220px;
    height: 120px;
    background-color: #ccc;

    &:nth-child(n + 6) {
      margin-top: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue